<!-- @format -->

<!--左侧菜单栏，超出两级后弹窗展示菜单-->
<template>
  <div>
    <div
      v-for="(item, index) in newMenuList"
      :key="index"
      class="nav-menu-item"
    >
      <slot
        name="menuItem"
        :data="item"
      >
        <el-menu-item
          :index="item[defaultProps.path]"
          v-if="item.type == 1&&item.showFlag!=0"
          @click="onMenuItemClick"
        >
          <svg-icon
            v-if="item[defaultProps.icon]"
            :icon-class="item[defaultProps.icon]"
          ></svg-icon>
          <span
            v-else
            class="svg-icon point"
          ></span>
          <span :class="!collapse ? 'menu-title' : ''">
            <text-tooltip
              style="display: inline-block; width: 100%"
              :content="item[defaultProps.name]"
              v-if="isTooltip"
            ></text-tooltip>
            <span v-else>{{ item[defaultProps.name] }}</span>
          </span>
        </el-menu-item>
      </slot>
      <el-submenu
        :ref="'submenu' + index"
        v-if="item.type == 0&&item.showFlag!=0"
        :index="item[defaultProps.path]"
        popper-class="submenuPop"
      >
        <!--  @click="onMenuItemClick(item)" -->
        <template slot="title">
          <svg-icon
            v-if="item[defaultProps.icon]"
            :icon-class="item[defaultProps.icon]"
            style="margin-top: 5px;"
          ></svg-icon>
          <span
            v-else
            class="svg-icon point"
          ></span>
          <span class="menu-title more">
            <text-tooltip
              style="display: inline-block; width: 100%"
              :content="item[defaultProps.name]"
            ></text-tooltip>
          </span>
          <!-- <svg-icon class="arrow" icon-class="right1"></svg-icon> -->
          <!-- <span slot="title">{{ item[defaultProps.name] }}11111111111</span> -->
        </template>
        <nav-menu
          :menuList="item[defaultProps.children]"
          :defaultProps="defaultProps"
          @getMenu="onMenuItemClick(item)"
          class="child-nav"
        ></nav-menu>
      </el-submenu>
    </div>
  </div>
</template>
<script>
import SvgIcon from "../SvgIcon.vue";
import TextTooltip from "../TextTooltip";
export default {
  name: "NavMenu",
  components: {
    SvgIcon,
    TextTooltip,
  },
  props: {
    collapse: {
      type: Boolean,
      default: false,
    },
    menuList: {
      type: Array,
      default() {
        return [];
      },
    },
    showWrap: {
      //菜单选中时是否显示上下小角
      type: Boolean,
      default: false,
    },
    defaultProps: {
      type: Object,
      default: () => {
        return {
          path: "path",
          icon: "icon",
          name: "name",
          children: "children",
        };
      },
    },
    isTooltip: {
      //超长时是否省略
      type: Boolean,
      default: true,
    },
    textShow: {
      // 隐藏文字，用于解决菜单收缩挤压文字问题
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      data: [],
      newMenuList: [],
    };
  },
  watch: {
    menuList: {
      immediate: true,
      handler(val) {
        this.newMenuList = val || [];
      },
    },
  },
  created() {},
  methods: {
    onMenuItemClick(item) {
      this.$emit("getMenu", item);
    },
  },
};
</script>
<style lang="scss" scoped>
:deep(.el-menu) {
  border-right: 0;
}
.el-menu-item {
  display: flex;
  align-items: center;
}
.menu-title {
  &.more {
    width: calc(100% - 36px);
  }
  flex: 1;
  overflow: hidden;
  // width: 100%;
  display: inline-block;
  white-space: normal;
  word-break: break-all;
  .more {
    width: calc(100% - 57px) !important;
  }
}
</style>
<style></style>
